export enum PromoRibbonStyle {
  PLUM = 'plum',
  GREEN = 'green',
  LIGHT_GREEN = 'light-green',
  BLACK = 'black',
  RED = 'red',
}

export enum RecentlyViewedClubRibbonStyle {
  PLUM = 'plum',
  GREEN = 'green',
  DARK_GREY = 'dark grey',
  PALE_GREEN = 'pale green',
}
